import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=03afeced&"
import script from "./KeywordSearch.vue?vue&type=script&lang=js&"
export * from "./KeywordSearch.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports